module.exports = __webpack_public_path__ + "static/media/theme-color-hint-2.821e927a.png";